import { createFileRoute } from "@tanstack/react-router";
import { JourneysPage } from "../../components/travel-journeys/journeys-page";
import { journeysSearchShape } from "../../components/travel-journeys/journeys-search";
import { z } from "zod";

/** `/logistics/arrival-departure/journeys` — the Journeys list (M9b §1). URL = state, in the API's keys; every param lenient. */
export const Route = createFileRoute("/_app/logistics/arrival-departure/journeys/")({
	validateSearch: z.object(journeysSearchShape),
	component: JourneysRoute,
});

function JourneysRoute() {
	const { session } = Route.useRouteContext();
	return <JourneysPage session={session} search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
